/* stockist-locator.v2.js: Chooki's stockist locator runtime (loop 403d05275938, T02 to T14).
 * Progressive enhancement over sections/stockist-locator.liquid: the directory, chips and badge are
 * server rendered and work without this file. This adds the list panel, distance search, Use my
 * location, the lazy Leaflet map and the store card.
 * Rules: every string from data goes in through textContent (never innerHTML); the only markup
 * built as strings is static pin and cluster art carrying numbers. No position ever leaves the
 * browser. Search works with no Leaflet at all. */
(function () {
  'use strict';

  var STATES = ['NSW', 'QLD', 'VIC', 'WA', 'SA', 'TAS', 'ACT', 'NT'];
  var STATE_NAMES = { NSW: 'New South Wales', QLD: 'Queensland', VIC: 'Victoria', WA: 'Western Australia', SA: 'South Australia', TAS: 'Tasmania', ACT: 'Australian Capital Territory', NT: 'Northern Territory' };
  var FAR_KM = 50, NEAR_KM = 15, PAGE_ALL = 8, PAGE_NEAR = 5, LONG_HOP_M = 1500e3;

  /* ------------------------------------------------------------ search core (pure) */
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9 ]/g, ' ').replace(/\bst\b/g, 'saint').replace(/\bmt\b/g, 'mount')
      .replace(/\bnth\b/g, 'north').replace(/\bsth\b/g, 'south').replace(/\baustralia\b/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function osa(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var p2 = null, p = [], i, j;
    for (j = 0; j <= b.length; j++) p.push(j);
    for (i = 1; i <= a.length; i++) {
      var c = [i], mn = i;
      for (j = 1; j <= b.length; j++) {
        var k = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + k);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, p2[j - 2] + 1);
        c[j] = v; if (v < mn) mn = v;
      }
      if (mn > max) return max + 1;
      p2 = p; p = c;
    }
    return p[b.length];
  }
  function km(a, b, c, d) {
    var r = Math.PI / 180, h = Math.pow(Math.sin((c - a) * r / 2), 2) + Math.cos(a * r) * Math.cos(c * r) * Math.pow(Math.sin((d - b) * r / 2), 2);
    return 2 * 6371 * Math.asin(Math.sqrt(h));
  }
  function fmtKm(k) { return k < 10 ? (Math.round(k * 10) / 10).toFixed(1) + ' km' : Math.round(k).toLocaleString('en-AU') + ' km'; }

  /* au-places.v1.js: "PPPP S LAT,LNG : NAME[~R][@DLA,DLO];..." in hundredths of a degree. */
  function buildPlaces(raw) {
    var st = raw.st.split(' '), lines = raw.d.split('\n'), pcs = {}, names = [], i;
    for (i = 0; i < lines.length; i++) {
      var ln = lines[i]; if (!ln) continue;
      var pc = ln.slice(0, 4), si = +ln.charAt(4), colon = ln.indexOf(':'), comma = ln.indexOf(',', 5);
      var la = +ln.slice(5, comma) / 100, lo = +ln.slice(comma + 1, colon) / 100, rest = ln.slice(colon + 1);
      var entry = { pc: pc, st: st[si], lat: la, lng: lo, label: null }, bar = rest.indexOf('|');
      if (bar >= 0) { /* dispersed postcode: measure a bare postcode search from its median */
        var md = rest.slice(bar + 1).split(','); entry.mlat = la + (+md[0]) / 100; entry.mlng = lo + (+md[1]) / 100; rest = rest.slice(0, bar);
      }
      pcs[pc] = entry;
      if (rest.charAt(0) === '!') { entry.label = rest.slice(1); entry.poOnly = true; continue; }
      var parts = rest.split(';');
      for (var j = 0; j < parts.length; j++) {
        var t = parts[j], at = t.indexOf('@'), dla = 0, dlo = 0, rank = 0;
        if (at >= 0) { var off = t.slice(at + 1).split(','); dla = +off[0]; dlo = +off[1]; t = t.slice(0, at); }
        var tl = t.indexOf('~'); if (tl >= 0) { rank = +t.slice(tl + 1); t = t.slice(0, tl); }
        var rec = { n: norm(t), name: t, st: entry.st, pc: pc, lat: la + dla / 100, lng: lo + dlo / 100, rank: rank, label: j === 0 };
        if (j === 0) entry.label = t;
        names.push(rec);
      }
    }
    names.sort(function (a, b) { return a.n < b.n ? -1 : a.n > b.n ? 1 : 0; });
    return { pcs: pcs, names: names, pcList: Object.keys(pcs).sort() };
  }
  function lowerBound(arr, key) {
    var lo = 0, hi = arr.length;
    while (lo < hi) { var m = (lo + hi) >> 1; if (arr[m].n < key) lo = m + 1; else hi = m; }
    return lo;
  }
  /* Rank: exact, prefix, fuzzy by edit distance, then the population proxy, then shorter name. */
  function suggestNames(P, q, state, limit) {
    var out = [], seen = {}, i, r;
    if (!q) return out;
    function push(rec, tier) {
      if (state && rec.st !== state) return;
      var key = rec.n + '|' + rec.st;
      if (seen[key] && seen[key].tier <= tier && (seen[key].tier < tier || seen[key].rec.rank >= rec.rank)) return;
      seen[key] = { rec: rec, tier: tier };
    }
    for (i = lowerBound(P.names, q); i < P.names.length && P.names[i].n.indexOf(q) === 0; i++) {
      r = P.names[i]; push(r, r.n === q ? 0 : 1);
    }
    var nPrefix = Object.keys(seen).length;
    if (nPrefix < 3 && q.length >= 4) {
      var max = q.length >= 7 ? 2 : 1, c0 = q.charAt(0), c1 = q.charAt(1);
      for (i = 0; i < P.names.length; i++) {
        r = P.names[i];
        var f = r.n.charAt(0); if (f !== c0 && f !== c1 && r.n.charAt(1) !== c0) continue;
        var d = osa(q, r.n, max);
        if (d > max && r.n.length > q.length) d = osa(q, r.n.slice(0, q.length), max) + 0.5;
        if (d <= max) push(r, 2 + d);
      }
    }
    Object.keys(seen).forEach(function (k) { out.push(seen[k]); });
    out.sort(function (a, b) {
      return (a.tier - b.tier) || (b.rec.rank - a.rec.rank) || (b.rec.label - a.rec.label) || (a.rec.n.length - b.rec.n.length) || (a.rec.n < b.rec.n ? -1 : 1);
    });
    return out.slice(0, limit || 6).map(function (x) { return x.rec; });
  }
  function nearestPc(P, pc, state) {
    var n = +pc, best = null, bd = 1e9;
    for (var i = 0; i < P.pcList.length; i++) {
      var e = P.pcs[P.pcList[i]];
      if (e.poOnly) continue;
      if (state && e.st !== state) continue;
      if (P.pcList[i].charAt(0) !== pc.charAt(0)) continue;
      var d = Math.abs(+P.pcList[i] - n);
      if (d < bd) { bd = d; best = e; }
    }
    return best;
  }
  /* parse(q) -> {kind:'empty'} | {kind:'pc', pc, words, state} | {kind:'name', words, state} */
  function parseQuery(q) {
    var s = norm(q), state = null, m;
    if (!s) return { kind: 'empty' };
    s = s.replace(/\b(nsw|vic|qld|sa|wa|tas|nt|act)\b/, function (x) { state = x.toUpperCase(); return ' '; }).replace(/\s+/g, ' ').trim();
    m = s.match(/(^|\s)(\d{3,4})(\s|$)/);
    var words = s.replace(/\d+/g, ' ').replace(/\s+/g, ' ').trim();
    if (m) { var pc = m[2]; while (pc.length < 4) pc = '0' + pc; return { kind: 'pc', pc: pc, words: words, state: state }; }
    if (/\d/.test(s) && !words) return { kind: 'bad', state: state };
    if (!words) return state ? { kind: 'state', state: state } : { kind: 'empty' };
    return { kind: 'name', words: words, state: state };
  }
  /* resolve -> {lat,lng,label,pc,type,note} or null. P may be null (places not loaded yet). */
  function resolve(P, parsed, pins, allowPinFallback) {
    if (parsed.kind === 'pc') {
      if (P) {
        var e = P.pcs[parsed.pc];
        if (e) {
          var pick = null;
          if (parsed.words) {
            var hits = P.names.filter(function (r) { return r.pc === parsed.pc && r.n.indexOf(parsed.words) === 0; });
            if (hits.length) pick = hits[0];
          }
          if (pick) return { lat: pick.lat, lng: pick.lng, label: pick.name + ' ' + e.st + ' ' + e.pc, pc: e.pc, type: 'postcode' };
          if (e.mlat != null) return { lat: e.mlat, lng: e.mlng, label: 'postcode ' + e.pc, pc: e.pc, type: 'postcode' };
          return { lat: e.lat, lng: e.lng, label: (e.label ? e.label + ' ' : '') + e.st + ' ' + e.pc, pc: e.pc, type: 'postcode' };
        }
        var near = nearestPc(P, parsed.pc, parsed.state);
        if (near) return { lat: near.lat, lng: near.lng, label: near.label + ' ' + near.st + ' ' + near.pc, pc: near.pc, type: 'postcode', note: 'We do not know ' + parsed.pc + ', so these are near ' + near.pc + '.' };
        return null;
      }
      if (!allowPinFallback) return undefined; /* undefined = wait for the places file */
      var own = pins.filter(function (p) { return p.postcode === parsed.pc; });
      if (own.length) {
        var la = 0, lo = 0; own.forEach(function (p) { la += p.lat; lo += p.lng; });
        return { lat: la / own.length, lng: lo / own.length, label: own[0].suburb + ' ' + own[0].state + ' ' + parsed.pc, pc: parsed.pc, type: 'postcode' };
      }
      return null;
    }
    if (parsed.kind === 'name') {
      if (!P) return undefined;
      var s = suggestNames(P, parsed.words, parsed.state, 1)[0];
      if (!s) return null;
      return pinCentre({ lat: s.lat, lng: s.lng, label: s.name + ' ' + s.st + ' ' + s.pc, pc: s.pc, type: 'suburb', name: s.name, st: s.st }, pins);
    }
    return null;
  }
  /* QA3-07: the interim places file gives some localities their postcode's point (Bateau Bay sits on the 2261
     Long Jetty point, so its own stores read 3.7 km away). When published pins carry the searched locality as
     their suburb, in the same state and within 25 km of the places point, the search centres on the median of
     those pins. The ABS locality swap (J05) is the real fix; this stays harmless after it. */
  function pinCentre(hit, pins) {
    if (!hit || hit.type !== 'suburb' || !hit.name || !pins) return hit;
    var n = norm(hit.name);
    var own = pins.filter(function (p) { return p.state === hit.st && norm(p.suburb) === n && km(hit.lat, hit.lng, p.lat, p.lng) <= 25; });
    if (!own.length) return hit;
    function med(a) { a = a.slice().sort(function (x, y) { return x - y; }); var m = a.length >> 1; return a.length % 2 ? a[m] : (a[m - 1] + a[m]) / 2; }
    var out = {}; for (var k in hit) if (Object.prototype.hasOwnProperty.call(hit, k)) out[k] = hit[k];
    out.lat = med(own.map(function (p) { return p.lat; })); out.lng = med(own.map(function (p) { return p.lng; })); out.centre = 'pins';
    return out;
  }
  function nearest(lat, lng, pins, state) {
    return pins.filter(function (p) { return !state || p.state === state; })
      .map(function (p) { return { p: p, km: km(lat, lng, p.lat, p.lng) }; })
      .sort(function (a, b) { return a.km - b.km; });
  }

  /* expose the pure core for tests (node and the acceptance runner); inert otherwise */
  var CORE = { norm: norm, osa: osa, km: km, fmtKm: fmtKm, buildPlaces: buildPlaces, suggestNames: suggestNames, parseQuery: parseQuery, resolve: resolve, pinCentre: pinCentre, nearest: nearest };
  if (typeof module !== 'undefined' && module.exports) { module.exports = CORE; return; }
  window.__stockistCore = CORE;

  /* ------------------------------------------------------------ helpers */
  function $(root, sel) { return root.querySelector(sel); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function readJSON(id) { var n = document.getElementById(id); if (!n) return null; try { return JSON.parse(n.textContent); } catch (e) { return null; } }
  function loadScript(src, ok, bad) {
    var s = document.createElement('script'); s.src = src; s.async = true;
    s.onload = ok; s.onerror = bad; document.head.appendChild(s); return s;
  }
  function loadCss(href) {
    if (document.querySelector('link[data-stl-css]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; l.setAttribute('data-stl-css', '');
    document.head.appendChild(l);
  }
  function isIOS() { return /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }
  function announce(msg) {
    var r = document.getElementById('screenreader-announce');
    if (!r) return;
    r.textContent = '';
    setTimeout(function () { r.textContent = msg; }, 60);
    clearTimeout(announce.t); announce.t = setTimeout(function () { r.textContent = ''; }, 6000);
  }
  /* QA-08: the live-region line for a search or Near me outcome. A far result leads with the far heading
     ('No Chooki's near X yet'), a no-near result names the store once, never 'Nearest' twice. */
  function outcomeLine(r, farHead, kmFmt) {
    if (!r.first) return r.head;
    var who = r.first.p.name + ', ' + kmFmt(r.first.km) + ' away.';
    if (r.far) return farHead + '. Nearest is ' + who;
    if (!r.near) return r.head + ': ' + r.first.p.name + '.';
    return r.head + '. Nearest is ' + who;
  }
  function publish(data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('stockist_search', data); } catch (e) { /* analytics never breaks search */ }
  }
  function tilt(id) { var h = 0, s = String(id); for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return (Math.abs(h) % 13) - 6; }
  function attrEsc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* QA3-05: a focused chip scrolls fully clear of the Loox tab gutter (the row's scroll-padding-inline-end on
     phones). Chrome's own focus scroll leaves a chip where it is while 32 px of it shows, so QLD kept its edge
     under the tab and a scrolled VIC or TAS could land there. Shared by the map's chip row and the directory's. */
  function chipsClearOfTab(ul) {
    ul.addEventListener('focusin', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('.stl-chip') : null;
      if (!c || ul.scrollWidth <= ul.clientWidth) return;
      var end = parseFloat(getComputedStyle(ul).scrollPaddingRight) || 0;
      var r = c.getBoundingClientRect(), u = ul.getBoundingClientRect();
      var over = r.right + 6 - (u.right - end), under = u.left + 6 - r.left;
      if (over > 0) ul.scrollLeft += Math.ceil(over); else if (under > 0) ul.scrollLeft -= Math.ceil(under);
    });
  }

  /* Jack 2026-09-25 ("state selection for the map and then state selection for the list"): the directory has its
     own state buttons, so a phone never scrolls back above the map to change state. They filter the DIRECTORY
     ONLY: the other states get the hidden attribute (every row stays in the server HTML) and nothing here touches
     the map, its chips or its list, just as the map chips never touch the directory. The row of buttons stays
     where it was on screen. Without JavaScript they are plain links to the state anchors. */
  function scrollByY(dy) { try { window.scrollBy({ top: dy, left: 0, behavior: 'instant' }); } catch (e) { window.scrollBy(0, dy); } }

  /* QA 2026-09-25 (D3, Jack: "It's too much scrolling on mobile"): below 900 px the directory's state buttons float
     at the top of the screen while the list is under them. #MainContent is overflow hidden, which kills
     position:sticky, so the row itself (the ul) goes position:fixed (class is-float on the nav) and the nav keeps
     its measured height in the page, so nothing below it moves. As the end of the list comes up, the row rides up
     with it. No new element. Off: section setting dir_float_states (no stl--dirfloat class, nothing is wired). */
  function floatRow(root, nav, ul, dir) {
    if (!root.classList.contains('stl--dirfloat') || !ul || !dir || !window.matchMedia) return null;
    var mq = window.matchMedia('(max-width: 899.98px)'), on = false, raf = 0, lw = window.innerWidth;
    function set(v, lift) {
      if (v !== on) {
        var sl = ul.scrollLeft;
        if (v) { nav.style.height = nav.offsetHeight + 'px'; nav.classList.add('is-float'); }
        else { nav.classList.remove('is-float'); nav.style.height = ''; ul.style.transform = ''; }
        ul.scrollLeft = sl;
        on = v;
      }
      if (on) ul.style.transform = lift < 0 ? 'translateY(' + Math.round(lift) + 'px)' : '';
    }
    function update() {
      raf = 0;
      if (!mq.matches) { set(false, 0); return; }
      var n = nav.getBoundingClientRect(), d = dir.getBoundingClientRect(), h = ul.offsetHeight;
      set(n.top < 0 && d.bottom > 0, d.bottom - h);
    }
    function sched() { if (!raf) raf = window.requestAnimationFrame ? window.requestAnimationFrame(update) : setTimeout(update, 16); }
    window.addEventListener('scroll', sched, { passive: true });
    /* a phone's toolbar hiding on scroll fires resize with only the height changed: re-measure only on a width change */
    window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; set(false, 0); } sched(); });
    if (mq.addEventListener) mq.addEventListener('change', sched); else if (mq.addListener) mq.addListener(sched);
    update();
    return { update: update, floating: function () { return on; } };
  }

  function dirChips(root) {
    var chips = root.querySelectorAll('[data-stl-dchip]'), blocks = root.querySelectorAll('[data-stl-dstate]');
    if (!chips.length || !blocks.length) return;
    var nav = chips[0].closest('.stl-dchips') || chips[0];
    var ul = chips[0].closest('.stl-chips__ul');
    if (ul) chipsClearOfTab(ul);
    var fl = null;
    try { fl = floatRow(root, nav, ul, nav.closest('.stl-dir')); } catch (e) { if (window.console) console.error('stockist directory float', e); }
    function show(code) {
      var floating = !!(fl && fl.floating()), y0 = nav.getBoundingClientRect().top, n = 0;
      Array.prototype.forEach.call(blocks, function (b) {
        var on = !code || b.getAttribute('data-stl-dstate') === code;
        b.hidden = !on;
        if (on) n += b.querySelectorAll('.stl-dr').length;
      });
      Array.prototype.forEach.call(chips, function (c) {
        if ((c.getAttribute('data-stl-dchip') || '') === code) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      if (floating) {
        /* picked from the floating row, deep in the list: land on the start of the chosen list, right under the
           row (the nav's place in the page goes to the top of the screen, where the floating row already is) */
        scrollByY(nav.getBoundingClientRect().top);
      } else {
        /* hiding blocks below the row never needs the page to move; undo any shift the browser made */
        var dy = nav.getBoundingClientRect().top - y0;
        if (Math.abs(dy) >= 1) scrollByY(dy);
      }
      if (fl) fl.update();
      announce(code ? 'Showing ' + n + (n === 1 ? ' stockist in ' : ' stockists in ') + STATE_NAMES[code] : 'Showing all ' + n + ' stockists');
    }
    Array.prototype.forEach.call(chips, function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        show(c.getAttribute('data-stl-dchip') || '');
      });
    });
  }

  /* ------------------------------------------------------------ the locator */
  function Locator(root) {
    var data = readJSON('stockists-data'), cfg = readJSON('stockists-config') || {};
    var pins = (data && Array.isArray(data.pins)) ? data.pins.filter(function (p) {
      return p && p.id != null && isFinite(p.lat) && isFinite(p.lng);
    }) : [];
    if (!pins.length) return;
    var assets = cfg.assets || {};
    var style = ['dot', 'lid', 'drop', 'sticker'].indexOf(cfg.pinStyle) >= 0 ? cfg.pinStyle : 'dot';
    var mqReduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    /* Jack 2026-09-25: phones stack the map and the list by default; the drag-up sheet only when the section asks for it */
    var mqSheet = (window.matchMedia && cfg.mobileLayout === 'sheet') ? matchMedia('(max-width: 899.98px)') : { matches: false };
    var coarse = window.matchMedia ? matchMedia('(pointer: coarse)').matches : false;
    var byId = {};
    pins.forEach(function (p) { p.id = String(p.id); byId[p.id] = p; });
    var ORDER = {}; STATES.forEach(function (s, i) { ORDER[s] = i; });
    var allSorted = pins.slice().sort(function (a, b) {
      return (ORDER[a.state] - ORDER[b.state]) || a.suburb.localeCompare(b.suburb) || a.name.localeCompare(b.name);
    });

    var ui = {
      form: $(root, '[data-stl-form]'), input: $(root, '[data-stl-input]'), sugg: $(root, '[data-stl-sugg]'),
      help: $(root, '[data-stl-help]'), locate: $(root, '[data-stl-locate]'), chips: root.querySelectorAll('[data-stl-chip]'),
      split: $(root, '[data-stl-split]'), mapwrap: $(root, '[data-stl-mapwrap]'), map: $(root, '[data-stl-map]'),
      mapTxt: $(root, '[data-stl-map-txt]'), hint: $(root, '[data-stl-hint]'), panel: $(root, '[data-stl-panel]'),
      grip: $(root, '[data-stl-grip]'), gripLabel: $(root, '[data-stl-grip-label]'), ph: $(root, '[data-stl-ph]'),
      clear: $(root, '[data-stl-clear]'), body: $(root, '[data-stl-body]'), card: $(root, '[data-stl-card]'),
      far: $(root, '[data-stl-far]'), farH: $(root, '[data-stl-far-h]'), list: $(root, '[data-stl-list]'),
      more: $(root, '[data-stl-more]')
    };
    var S = { state: '', mode: 'all', origin: null, results: null, shown: PAGE_ALL, sel: null, opener: null, places: null, placesState: 'idle', pendingQuery: null, activeSugg: -1, suggs: [] };
    var M = { state: 'idle', map: null, cluster: null, markers: {}, here: null, you: null, allBounds: null };
    var sheet = { pos: 'peek' };
    root.classList.add('stl--js');
    /* the directory's "show on map" buttons ship disabled so they are inert without JavaScript */
    Array.prototype.forEach.call(root.querySelectorAll('[data-stl-show][disabled]'), function (b) { b.disabled = false; });

    /* ---------------- list panel ---------------- */
    function stateFilter(arr) { return S.state ? arr.filter(function (x) { return (x.p || x).state === S.state; }) : arr; }
    function pinArt(p, sel, small) {
      if (style === 'drop') return dropSVG(sel, small);
      /* Jack 2026-09-25: the red dot, a plain Tomato Red circle; selected turns Chooki Yellow like the other styles */
      if (style === 'dot') { var o = el('div', 'stl-pin-dot'); if (small) o.classList.add('stl-pin-dot--sm'); if (sel) o.classList.add('is-sel'); return o.outerHTML; }
      var d = el('div', style === 'lid' ? 'stl-pin-lid' : 'stl-pin-stk');
      if (small) d.classList.add(style === 'lid' ? 'stl-pin-lid--sm' : 'stl-pin-stk--sm');
      if (sel) d.classList.add('is-sel');
      if (style === 'sticker') d.style.setProperty('--r', tilt(p.id) + 'deg');
      return d.outerHTML;
    }
    function rowFor(p, k) {
      var li = el('li'), b = el('button', 'stl-row');
      b.type = 'button'; b.setAttribute('data-stl-row', p.id);
      /* the accessible name is the visible text ("Name, Suburb STATE, 2.3 km"), commas visually hidden */
      var ic = el('span', 'stl-row__ic'); ic.setAttribute('aria-hidden', 'true'); ic.innerHTML = pinArt(p, false, true);
      var mid = el('span'); var n = el('span', 'stl-row__n'); n.appendChild(el('span', null, p.name));
      mid.appendChild(n); mid.appendChild(el('span', 'stl-vh', ', ')); mid.appendChild(el('span', 'stl-row__s', p.suburb + ' ' + p.state));
      b.appendChild(ic); b.appendChild(mid);
      if (k != null) { var kk = el('span', 'stl-row__k'); kk.appendChild(el('span', 'stl-vh', ', ')); kk.appendChild(document.createTextNode(fmtKm(k))); b.appendChild(kk); }
      if (S.sel === p.id) b.classList.add('is-sel');
      li.appendChild(b);
      return li;
    }
    function render() {
      var items, total, head, far = false, near = 0;
      ui.list.textContent = '';
      if (S.mode === 'all') {
        items = stateFilter(allSorted).map(function (p) { return { p: p, km: null }; });
        total = items.length;
        /* QA-07: pins are locations (the badge reads 'N stockists in M locations'), so the panel says locations */
        head = S.state ? total + (total === 1 ? ' location in ' : ' locations in ') + STATE_NAMES[S.state] : total + ' locations across Australia';
      } else {
        items = stateFilter(S.results);
        total = items.length;
        var place = S.mode === 'near' ? 'you' : S.origin.label, q = S.state ? S.state + ' ' : '';
        var first = items[0];
        if (!first) head = 'No stockists in ' + STATE_NAMES[S.state] + ' yet';
        else if (first.km > FAR_KM) { far = true; head = 'Nearest ' + q + 'stockist is ' + fmtKm(first.km) + ' from ' + place; }
        else {
          var n = items.filter(function (x) { return x.km <= NEAR_KM; }).length; near = n;
          head = n > 1 ? n + ' ' + q + 'stockists near ' + place : (n === 1 ? '1 ' + q + 'stockist near ' + place : 'Nearest ' + q + 'stockist is ' + fmtKm(first.km) + ' from ' + place);
        }
      }
      ui.ph.textContent = head;
      ui.far.hidden = !far;
      if (far) ui.farH.textContent = S.mode === 'near' ? 'No Chooki\'s near you yet' : 'No Chooki\'s near ' + S.origin.label + ' yet';
      var limit = far ? Math.max(3, Math.min(S.shown, 3)) : S.shown;
      if (far && S.shown > PAGE_NEAR) limit = S.shown - PAGE_NEAR + 3;
      items.slice(0, limit).forEach(function (x) { ui.list.appendChild(rowFor(x.p, x.km)); });
      var rest = total - Math.min(limit, total);
      var step = S.mode === 'all' ? PAGE_ALL : PAGE_NEAR;
      ui.more.hidden = rest <= 0;
      ui.more.textContent = 'Show ' + Math.min(step, rest) + ' more';
      ui.clear.hidden = S.mode === 'all' && !S.state;
      placeCard();
      return { head: head, far: far, first: items[0], near: near };
    }
    ui.more.addEventListener('click', function () {
      S.shown += S.mode === 'all' ? PAGE_ALL : PAGE_NEAR;
      var before = ui.list.children.length;
      render();
      var next = ui.list.children[before]; if (next) { var b = next.querySelector('button'); if (b) b.focus(); }
    });
    ui.list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-stl-row]'); if (!b) return;
      select(b.getAttribute('data-stl-row'), { opener: b, from: 'row' });
    });

    /* ---------------- card ---------------- */
    function directions(p) {
      var q = encodeURIComponent(p.name + ', ' + p.address);
      var g = { label: 'Google Maps', href: 'https://www.google.com/maps/dir/?api=1&destination=' + q };
      var a = { label: 'Apple Maps', href: 'https://maps.apple.com/?daddr=' + encodeURIComponent(p.address) + '&q=' + encodeURIComponent(p.name) + '&ll=' + p.lat + ',' + p.lng };
      return isIOS() ? [a, g] : [g, a];
    }
    function buildCard(p) {
      var c = ui.card, k = null;
      c.textContent = '';
      if (S.origin) k = km(S.origin.lat, S.origin.lng, p.lat, p.lng);
      var x = el('button', 'stl-card__x', '\u00d7'); x.type = 'button'; x.setAttribute('aria-label', 'Close store details');
      x.addEventListener('click', function () { closeCard(true); });
      var wrap = c;
      if (style === 'lid' || style === 'dot') { var bt = el('div', 'stl-card__bottle'); bt.setAttribute('role', 'img'); bt.setAttribute('aria-label', 'A jar of Chooki\'s'); c.appendChild(bt); wrap = el('div'); c.appendChild(wrap); }
      if (style === 'drop') { var burst = el('div', 'stl-card__burst'); burst.setAttribute('aria-hidden', 'true'); burst.innerHTML = '<svg viewBox="0 0 100 100"><polygon points="50,2 58,20 77,10 76,31 97,33 84,50 97,67 76,69 77,90 58,80 50,98 42,80 23,90 24,69 3,67 16,50 3,33 24,31 23,10 42,20"/></svg><span>Stockist</span>'; c.appendChild(burst); }
      wrap.appendChild(el('span', 'stl-card__loc', p.suburb + ' ' + p.state));
      var h = el('h3', 'stl-card__n'); h.id = c.getAttribute('aria-labelledby'); h.tabIndex = -1;
      var hs = el('span', null, p.name); h.appendChild(hs); wrap.appendChild(h);
      wrap.appendChild(el('p', 'stl-card__a', p.address));
      if (k != null) wrap.appendChild(el('p', 'stl-card__k', fmtKm(k) + (S.mode === 'near' ? ' from you' : ' from ' + S.origin.label)));
      var acts = el('p', 'stl-card__acts'), d = directions(p);
      var main = el('a', 'stl-btn' + (style === 'drop' ? '' : ''), style === 'sticker' ? 'Directions' : 'Get directions');
      main.href = d[0].href; main.target = '_blank'; main.rel = 'noopener';
      main.setAttribute('aria-label', 'Get directions to ' + p.name + ' in ' + d[0].label + ' (opens in a new tab)');
      var alt = el('a', 'stl-txtlink', d[1].label);
      alt.href = d[1].href; alt.target = '_blank'; alt.rel = 'noopener';
      alt.setAttribute('aria-label', 'Directions to ' + p.name + ' in ' + d[1].label + ' (opens in a new tab)');
      acts.appendChild(main); acts.appendChild(alt); wrap.appendChild(acts);
      c.appendChild(x);
    }
    function placeCard() {
      if (ui.card.hidden || !S.sel) return;
      if (style === 'sticker') {
        var row = ui.list.querySelector('[data-stl-row="' + cssEsc(S.sel) + '"]');
        if (row) { row.parentNode.appendChild(ui.card); return; }
      }
      if (ui.card.parentNode !== ui.body || ui.body.firstChild !== ui.card) ui.body.insertBefore(ui.card, ui.body.firstChild);
    }
    function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }
    function openCard(id, focusIt) {
      var p = byId[id]; if (!p || S.sel !== id) return;
      buildCard(p);
      ui.card.hidden = false;
      placeCard();
      var r = ui.list.querySelector('[data-stl-row="' + cssEsc(id) + '"]');
      if (style === 'sticker' && r) scrollInto(r.parentNode, ui.body);
      else ui.body.scrollTop = 0;
      /* QA-01: phones snap the sheet to the height the whole card needs (Directions included), after
         growing the map box so a strip of map with the pin still shows above it */
      if (mqSheet.matches) { setCardFit(cardNeed()); setSheet('card'); keepCardInView(); }
      if (focusIt) { var h = ui.card.querySelector('.stl-card__n'); if (h) h.focus({ preventScroll: true }); }
    }
    function closeCard(returnFocus, reopening) {
      if (ui.card.hidden) return;
      ui.card.hidden = true; ui.card.textContent = '';
      ui.body.insertBefore(ui.card, ui.body.firstChild);
      setSelected(null);
      if (!reopening && mqSheet.matches) { setCardFit(0); if (sheet.pos === 'card') setSheet('half'); }
      if (returnFocus && S.opener && document.body.contains(S.opener)) S.opener.focus();
      S.opener = null;
    }
    /* ---- phones: the open card and the map strip above it (QA-01) ---- */
    var MIN_STRIP = 170; /* floating chips (58 px) plus the zoom buttons (to 162 px) stay clear of the sheet */
    function offsetIn(node, anc) {
      var y = 0;
      while (node && node !== anc) { y += node.offsetTop; node = node.offsetParent; }
      return node === anc ? y : null;
    }
    /* sheet height that shows the whole open card, measured in layout (not transformed) pixels */
    function cardNeed() {
      if (ui.card.hidden) return 0;
      var y = offsetIn(ui.card, ui.panel);
      if (y == null) y = ui.card.getBoundingClientRect().top - ui.panel.getBoundingClientRect().top + ui.body.scrollTop;
      return Math.ceil(y - ui.body.scrollTop + ui.card.offsetHeight + 14);
    }
    /* grow the map box (never past the viewport under a sticky header) so card plus strip both fit */
    function setCardFit(need) {
      if (!ui.mapwrap) return;
      var wrap = ui.mapwrap, before = wrap.offsetHeight, prev = wrap.style.height;
      wrap.style.height = '';
      if (need && mqSheet.matches && !root.classList.contains('stl--nomap')) {
        var base = wrap.offsetHeight, max = Math.max(base, window.innerHeight - stickyTop() - 16);
        var want = Math.min(max, Math.max(base, need + MIN_STRIP, Math.ceil(need / 0.88)));
        if (want > base + 1) wrap.style.height = want + 'px';
      }
      if (wrap.offsetHeight !== before || wrap.style.height !== prev) {
        if (M.map) M.map.invalidateSize({ pan: false });
        if (mqSheet.matches) setSheet(sheet.pos, true);
      }
    }
    /* build the card out of sight to measure it, size the map for it, and return the sheet cover the
       camera must frame the pin above (all in one task, so nothing paints in between) */
    function prepCard(p) {
      buildCard(p); ui.card.hidden = false; placeCard();
      if (style !== 'sticker') ui.body.scrollTop = 0;
      var need = cardNeed();
      ui.card.hidden = true; ui.card.textContent = '';
      setCardFit(need);
      var m = sheetMetrics();
      return m.h - Math.max(0, Math.min(m.half, m.h - need));
    }
    /* when even the tallest sheet cannot show the whole card (a phone on its side), scroll the list so
       the Directions button sits on screen instead of under the bottom of the sheet */
    function keepCardInView() {
      var m = sheetMetrics(), vis = m.h - m.card;
      var y = offsetIn(ui.card, ui.panel); if (y == null) return;
      var bottom = y - ui.body.scrollTop + ui.card.offsetHeight + 8;
      if (bottom > vis) ui.body.scrollTop += Math.ceil(bottom - vis);
    }
    function scrollInto(node, box) {
      var nt = node.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop, bt = box.scrollTop, bh = box.clientHeight;
      if (nt < bt || nt + node.offsetHeight > bt + bh) box.scrollTop = Math.max(0, nt - 8);
    }

    /* ---------------- selection ---------------- */
    function setSelected(id) {
      var prev = S.sel; S.sel = id;
      Array.prototype.forEach.call(root.querySelectorAll('.stl-row.is-sel,.stl-dr.is-sel'), function (n) { n.classList.remove('is-sel'); });
      if (id) {
        var r = ui.list.querySelector('[data-stl-row="' + cssEsc(id) + '"]'); if (r) r.classList.add('is-sel');
        var d = document.getElementById('pin-' + id); if (d) d.classList.add('is-sel');
      }
      if (M.map) {
        if (prev && M.markers[prev]) { M.markers[prev].setIcon(pinIcon(byId[prev], false)); M.markers[prev].setZIndexOffset(0); }
        if (id && M.markers[id]) { M.markers[id].setIcon(pinIcon(byId[id], true)); M.markers[id].setZIndexOffset(1000); }
      }
    }
    /* a selected pin hidden in a co-located cluster is spiderfied into view */
    function reveal(id) {
      var mk = M.markers[id]; if (!mk || mk._icon || !M.cluster || S.sel !== id) return;
      /* right after a zooming flight markercluster runs a 200 ms merge animation and ignores spiderfy()
         until it ends, so the co-located pin stayed folded in its "2"; wait for that animation */
      if (M.cluster._inZoomAnimation) { M.cluster.once('animationend', function () { reveal(id); }); return; }
      var vp = M.cluster.getVisibleParent(mk);
      if (vp && vp !== mk && vp.spiderfy) vp.spiderfy();
    }
    /* phones: the centre that puts a pin in the middle of the map strip between the chips and the half sheet */
    function visibleCenter(ll, z, cover) {
      var s = M.map.getSize(), m = sheetMetrics(), top = 64;
      if (cover == null) cover = m.h - m.half;
      var want = top + Math.max(40, (s.y - cover - attrH() - top)) / 2;
      return M.map.unproject(M.map.project(L.latLng(ll), z).add([0, s.y / 2 - want]), z);
    }
    function select(id, o) {
      o = o || {};
      var p = byId[id]; if (!p) return;
      closeCard(false, true);
      S.opener = o.opener || null;
      setSelected(id);
      if (o.from === 'dir' && S.state && S.state !== p.state) setChip('', true);
      /* phones: a pin tap grows and scrolls too, or the card opens below the fold (QA-01) */
      var cover = null;
      if (o.from !== 'pin' || mqSheet.matches) { grow(); if (mqSheet.matches) cover = prepCard(p); scrollToMap(); }
      ensureMap();
      var focusIt = o.from !== 'pin';
      if (M.map) {
        var z = Math.min(Math.max(M.map.getZoom(), 15), 16);
        var at = mqSheet.matches ? visibleCenter([p.lat, p.lng], z, cover) : [p.lat, p.lng];
        moveThen({ latlng: at, zoom: z }, {}, function () { reveal(id); openCard(id, focusIt); });
      } else openCard(id, focusIt);
    }

    /* ---------------- chips ---------------- */
    function setChip(code, quiet) {
      S.state = code;
      Array.prototype.forEach.call(ui.chips, function (c) {
        if (c.getAttribute('data-stl-chip') === code) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      S.shown = S.mode === 'all' ? PAGE_ALL : PAGE_NEAR;
      closeCard(false);
      var r = render();
      syncMarkers();
      if (quiet) return;
      announce(r.head);
      ensureMap();
      if (!M.map) return;
      if (S.mode === 'all') { if (code) fitPins(stateFilter(pins)); else resetView(); }
      else fitResults();
    }
    Array.prototype.forEach.call(ui.chips, function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        setChip(c.getAttribute('data-stl-chip') || '');
      });
    });
    var chipUl = ui.chips.length ? ui.chips[0].closest('.stl-chips__ul') : null;
    if (chipUl) chipsClearOfTab(chipUl);

    /* ---------------- search ---------------- */
    var PLACES_DOWN = 'Suburb search is unavailable right now. Try a postcode, like 2250.';
    function loadPlaces(cb) {
      if (S.places) { if (cb) cb(); return; }
      /* QA3-04: a failed file answers at once; nothing waits on a load that will never come */
      if (S.placesState === 'failed') { if (cb) cb(); return; }
      var q0 = loadPlaces.q = loadPlaces.q || [];
      if (cb && q0.indexOf(cb) < 0) q0.push(cb);
      if (S.placesState !== 'idle') return;
      S.placesState = 'loading';
      loadScript(assets.places, function () {
        try { S.places = buildPlaces(window.__chookiPlaces); S.placesState = 'ready'; } catch (e) { S.placesState = 'failed'; }
        var q = loadPlaces.q || []; loadPlaces.q = []; q.forEach(function (f) { f(); });
      }, function () { S.placesState = 'failed'; loadPlaces.failedAt = Date.now(); var q = loadPlaces.q || []; loadPlaces.q = []; q.forEach(function (f) { f(); }); });
    }
    function setHelp(msg, invalid) {
      ui.help.textContent = msg || '';
      if (invalid) ui.input.setAttribute('aria-invalid', 'true'); else ui.input.removeAttribute('aria-invalid');
    }
    function runSearch(raw, opts) {
      opts = opts || {};
      var parsed = parseQuery(raw);
      hideSugg();
      if (parsed.kind === 'empty') { setHelp(''); return; }
      if (parsed.kind === 'state') { setHelp(''); setChip(parsed.state); return; }
      if (parsed.kind === 'bad') { setHelp('We couldn\'t find ' + raw.trim() + '. Try a suburb or postcode.', true); announce(ui.help.textContent); return; }
      var hit = opts.place || resolve(S.places, parsed, pins, S.placesState === 'failed');
      if (hit === undefined) {
        /* QA4-01: a submitted search retries a failed places file once before saying it is down */
        if (S.placesState === 'failed' && !opts.placesRetried) { opts.placesRetried = true; S.placesState = 'idle'; }
        setHelp('Loading suburbs...');
        loadPlaces(function () {
          if (S.placesState === 'failed' && parsed.kind === 'name') { setHelp(PLACES_DOWN, true); announce(PLACES_DOWN); return; }
          if (S.placesState !== 'ready' && S.placesState !== 'failed') return;
          runSearch(raw, opts);
        });
        return;
      }
      if (!hit) { setHelp('We couldn\'t find ' + raw.trim() + '. Try a suburb or postcode.', true); announce(ui.help.textContent); return; }
      setHelp(hit.note || '');
      if (parsed.state && !S.state && parsed.kind === 'name') { /* state token filters suggestions only */ }
      S.mode = 'search'; S.origin = hit; S.shown = PAGE_NEAR;
      S.results = nearest(hit.lat, hit.lng, pins);
      closeCard(false);
      var r = render();
      syncMarkers();
      var first = r.first;
      announce(outcomeLine(r, ui.farH.textContent, fmtKm));
      publish({ query_type: hit.type, postcode: hit.pc || null, nearest_km: first ? Math.round(first.km) : null, results: r.near });
      if (!opts.fromUrl) { writeUrl(raw.trim()); grow(); }
      if (mqSheet.matches) setSheet('half');
      if (!opts.fromUrl) scrollToMap();
      ensureMap();
      if (M.map) fitResults();
    }
    function writeUrl(q) {
      try { var u = new URL(location.href); if (q) u.searchParams.set('q', q); else u.searchParams.delete('q'); history.replaceState(history.state, '', u.toString()); } catch (e) { /* old browser */ }
    }
    ui.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (S.activeSugg >= 0 && S.suggs[S.activeSugg]) { pickSugg(S.activeSugg); return; }
      runSearch(ui.input.value);
    });
    /* a places file that failed once (a blip during the idle prefetch) gets one more try when the shopper comes to search */
    /* QA4-01: a failed places file is retried on every focus, on every submitted search and when the browser comes back online, so one blip never leaves suburb search dead */
    function retryPlaces() { if (S.placesState === 'failed') S.placesState = 'idle'; loadPlaces(); }
    ui.input.addEventListener('focus', retryPlaces);
    window.addEventListener('online', function () { if (S.placesState === 'failed') retryPlaces(); });
    ui.input.addEventListener('pointerdown', function () { loadPlaces(); });

    /* combobox suggestions (T09) */
    var sid = ui.sugg.id, deb = 0;
    function hideSugg() {
      ui.sugg.hidden = true; ui.sugg.textContent = ''; S.suggs = []; S.activeSugg = -1;
      ui.input.setAttribute('aria-expanded', 'false'); ui.input.removeAttribute('aria-activedescendant');
    }
    function showSugg(list, loading) {
      ui.sugg.textContent = ''; S.suggs = list; S.activeSugg = -1; ui.input.removeAttribute('aria-activedescendant');
      if (loading) { var l = el('li', null, 'Loading suburbs...'); l.setAttribute('role', 'option'); l.setAttribute('aria-disabled', 'true'); ui.sugg.appendChild(l); }
      list.forEach(function (r, i) {
        var li = el('li'); li.id = sid + '-o' + i; li.setAttribute('role', 'option'); li.setAttribute('aria-selected', 'false');
        li.appendChild(el('span', null, r.name)); li.appendChild(el('small', null, r.st + ' ' + r.pc));
        li.addEventListener('mousedown', function (e) { e.preventDefault(); });
        li.addEventListener('click', function () { pickSugg(i); });
        ui.sugg.appendChild(li);
      });
      var any = list.length || loading;
      ui.sugg.hidden = !any; ui.input.setAttribute('aria-expanded', any ? 'true' : 'false');
    }
    function activate(i) {
      var opts = ui.sugg.querySelectorAll('[role="option"]:not([aria-disabled])');
      if (!opts.length) return;
      S.activeSugg = (i + opts.length) % opts.length;
      Array.prototype.forEach.call(opts, function (o, j) { o.setAttribute('aria-selected', j === S.activeSugg ? 'true' : 'false'); });
      ui.input.setAttribute('aria-activedescendant', opts[S.activeSugg].id);
      opts[S.activeSugg].scrollIntoView({ block: 'nearest' });
    }
    function pickSugg(i) {
      var r = S.suggs[i]; if (!r) return;
      ui.input.value = r.name + ' ' + r.st + ' ' + r.pc;
      runSearch(ui.input.value, { place: pinCentre({ lat: r.lat, lng: r.lng, label: r.name + ' ' + r.st + ' ' + r.pc, pc: r.pc, type: 'suburb', name: r.name, st: r.st }, pins) });
    }
    function suggestNow() {
      var parsed = parseQuery(ui.input.value);
      if (parsed.kind !== 'name' || parsed.words.length < 2) {
        if (parsed.kind === 'pc' && S.places && S.places.pcs[parsed.pc] && !S.places.pcs[parsed.pc].poOnly) {
          var e = S.places.pcs[parsed.pc];
          var own = S.places.names.filter(function (r) { return r.pc === e.pc; }).sort(function (a, b) { return b.label - a.label || b.rank - a.rank; }).slice(0, 6);
          return showSugg(own);
        }
        return hideSugg();
      }
      if (!S.places) {
        if (S.placesState === 'failed') { hideSugg(); setHelp(PLACES_DOWN); return; }
        showSugg([], true); loadPlaces(suggestNow); return;
      }
      showSugg(suggestNames(S.places, parsed.words, parsed.state, 6));
    }
    ui.input.addEventListener('input', function () { setHelp(''); clearTimeout(deb); deb = setTimeout(suggestNow, 120); });
    ui.input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (ui.sugg.hidden) suggestNow(); else activate(S.activeSugg + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activate(S.activeSugg - 1); }
      else if (e.key === 'Escape') { if (!ui.sugg.hidden) { e.stopPropagation(); hideSugg(); } }
    });
    ui.input.addEventListener('blur', function () { setTimeout(hideSugg, 150); });

    /* clear */
    ui.clear.addEventListener('click', function () {
      S.mode = 'all'; S.origin = null; S.results = null; S.shown = PAGE_ALL;
      ui.input.value = ''; setHelp(''); writeUrl('');
      if (M.you) { M.map.removeLayer(M.you); M.you = null; }
      if (M.here) { M.map.removeLayer(M.here); M.here = null; }
      setChip('', true);
      announce(ui.ph.textContent);
      if (mqSheet.matches) setSheet('peek');
      if (M.map) resetView();
      ui.input.focus();
    });

    /* ---------------- Use my location (T08): the position never leaves the browser ---------------- */
    /* shown by default (hidden only with no JS, via noscript) so enabling it never shifts the search box */
    if (ui.locate && !navigator.geolocation) ui.locate.hidden = true;
    if (ui.locate && navigator.geolocation) {
      ui.locate.addEventListener('click', function () {
        ui.locate.setAttribute('aria-busy', 'true');
        navigator.geolocation.getCurrentPosition(function (pos) {
          ui.locate.removeAttribute('aria-busy');
          var la = pos.coords.latitude, lo = pos.coords.longitude;
          S.mode = 'near'; S.origin = { lat: la, lng: lo, label: 'you', type: 'near_me' }; S.shown = PAGE_NEAR;
          S.results = nearest(la, lo, pins);
          ui.input.value = ''; setHelp(''); writeUrl('');
          closeCard(false);
          var r = render(); syncMarkers();
          announce(outcomeLine(r, ui.farH.textContent, fmtKm));
          /* QA-11: results is the count the panel heading shows (stockists within NEAR_KM), 0 when none are near */
          publish({ query_type: 'near_me', postcode: null, nearest_km: r.first ? Math.round(r.first.km) : null, results: r.near });
          grow();
          if (mqSheet.matches) setSheet('half');
          scrollToMap();
          ensureMap();
          if (M.map) fitResults(true);
        }, function (err) {
          ui.locate.removeAttribute('aria-busy');
          setHelp(err && err.code === 1 ? 'No worries, pop your postcode in instead.' : 'Could not find you, try your postcode.');
          ui.input.focus();
        }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
      });
    }

    /* ---------------- directory "Show on map" ---------------- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-stl-show]'); if (!b) return;
      select(b.getAttribute('data-stl-show'), { opener: b, from: 'dir' });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!ui.sugg.hidden) { hideSugg(); return; }
      if (!ui.card.hidden) { closeCard(true); }
    });
    /* the bottom edge of any fixed or sticky header over the top of the page right now */
    function stickyTop() {
      var el = document.elementFromPoint(window.innerWidth / 2, 2);
      while (el && el !== document.body && el !== document.documentElement) {
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'sticky') { var r = el.getBoundingClientRect(); return (r.top <= 2 && r.bottom < window.innerHeight / 2) ? r.bottom : 0; }
        el = el.parentElement;
      }
      return 0;
    }
    /* phones: the map starts short enough for the first viewport (T04) and grows to 60vh once the shopper
       searches or picks a store; the resize follows their input, so it is not a layout shift (CLS) */
    function grow() {
      if (!mqSheet.matches || root.classList.contains('stl--tall') || root.classList.contains('stl--nomap')) return;
      root.classList.add('stl--tall');
      if (M.map) M.map.invalidateSize({ pan: false });
      setSheet(sheet.pos, true);
    }
    /* bring the map into view when less than three quarters of it shows (spec 4.8) */
    function scrollToMap() {
      var t = ui.mapwrap || ui.split;
      if (!t || root.classList.contains('stl--nomap')) return;
      var r = t.getBoundingClientRect(), vh = window.innerHeight, top = stickyTop();
      var visible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, top));
      /* phones: the map top goes under the header after every search (spec 4.8); desktop: only when mostly hidden */
      if (mqSheet.matches ? (Math.abs(r.top - top) < 24 && r.bottom <= vh + 4) : visible >= Math.min(r.height, vh - top) * 0.75) return;
      S.scrolledAt = Date.now();
      window.scrollTo({ top: Math.max(0, window.scrollY + r.top - top - 8), behavior: mqReduce.matches ? 'auto' : 'smooth' });
    }

    /* ---------------- bottom sheet (phones and tablets) ---------------- */
    function sheetMetrics() {
      var wrapH = ui.mapwrap.clientHeight, h = ui.panel.offsetHeight, peek = 96, half = Math.max(0, h - wrapH * 0.5);
      var need = cardNeed();
      /* 'card': the whole open card shows, never less of the sheet than half (QA-01) */
      return { wrapH: wrapH, h: h, peek: h - peek, half: half, full: 0, card: need ? Math.max(0, Math.min(half, h - need)) : half };
    }
    function setSheet(pos, instant) {
      if (!mqSheet.matches || root.classList.contains('stl--nomap')) return;
      sheet.pos = pos;
      var m = sheetMetrics(), y = m[pos];
      if (instant) ui.panel.classList.add('is-dragging');
      ui.panel.style.transform = 'translate3d(0,' + y + 'px,0)';
      if (instant) { void ui.panel.offsetHeight; ui.panel.classList.remove('is-dragging'); }
      syncSheetH();
      ui.grip.setAttribute('aria-expanded', pos === 'peek' ? 'false' : 'true');
      ui.gripLabel.textContent = pos === 'full' ? 'Show less of the list' : 'Show more of the list';
    }
    function sheetVisible() { if (!mqSheet.matches) return 0; var m = sheetMetrics(); return m.h - m[sheet.pos]; }
    /* how much of the map's bottom the sheet hides right now (sticky sheet: more while the map runs past the fold) */
    function sheetCover() {
      if (!mqSheet.matches) return 0;
      var mr = ui.map.getBoundingClientRect(), vis = sheetVisible();
      /* the sheet is not sticky, so the part past the fold already contains it: hidden = the larger of
         the two, never their sum (the sum inverted the 320 px fit box to zoom 19, QA-02) */
      return Math.max(vis, Math.round(mr.bottom - Math.min(mr.bottom, window.innerHeight)));
    }
    function syncSheetH() { ui.mapwrap.style.setProperty('--stl-sheet-h', sheetCover() + 'px'); }
    var scrollRaf = 0;
    window.addEventListener('scroll', function () {
      if (!mqSheet.matches || scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () { scrollRaf = 0; syncSheetH(); });
    }, { passive: true });
    ui.grip.addEventListener('click', function () {
      if (sheet.dragged) return;
      setSheet(sheet.pos === 'peek' ? 'half' : (sheet.pos === 'half' || sheet.pos === 'card') ? 'full' : 'peek');
    });
    (function sheetDrag() {
      var startY = 0, startT = 0, base = 0, lastY = 0, lastT = 0, v = 0, dragging = false, pid = null;
      function down(e) {
        if (!mqSheet.matches || root.classList.contains('stl--nomap')) return;
        if (e.target.closest('.stl-panel__body') && !e.target.closest('.stl-grip')) return;
        if (e.target.closest('button') && !e.target.closest('.stl-grip')) return;
        dragging = true; pid = e.pointerId; sheet.dragged = false;
        var m = sheetMetrics(); base = m[sheet.pos];
        startY = lastY = e.clientY; startT = lastT = e.timeStamp; v = 0;
      }
      function move(e) {
        if (!dragging || e.pointerId !== pid) return;
        var dy = e.clientY - startY;
        if (!sheet.dragged) {
          if (Math.abs(dy) <= 4) return;
          /* capture only once it is a drag, so a tap on the grip stays a click on the grip */
          sheet.dragged = true; ui.panel.classList.add('is-dragging');
          try { ui.panel.setPointerCapture(pid); } catch (x) { /* ok */ }
        }
        var m = sheetMetrics(), y = Math.min(m.peek, Math.max(0, base + dy));
        ui.panel.style.transform = 'translate3d(0,' + y + 'px,0)';
        var dt = e.timeStamp - lastT; if (dt > 0) v = (e.clientY - lastY) / dt;
        lastY = e.clientY; lastT = e.timeStamp;
      }
      function up(e) {
        if (!dragging || e.pointerId !== pid) return;
        dragging = false; ui.panel.classList.remove('is-dragging');
        if (!sheet.dragged) return;
        var m = sheetMetrics(), y = Math.min(m.peek, Math.max(0, base + (e.clientY - startY)));
        var snaps = [['full', m.full], ['half', m.half], ['peek', m.peek]], pick;
        if (!ui.card.hidden) snaps.push(['card', m.card]);
        if (Math.abs(v) > 0.5) {
          var order = ['full', 'half', 'peek'], i = order.indexOf(sheet.pos === 'card' ? 'half' : sheet.pos);
          pick = v > 0 ? order[Math.min(2, i + 1)] : order[Math.max(0, i - 1)];
        } else {
          pick = snaps.reduce(function (a, b) { return Math.abs(b[1] - y) < Math.abs(a[1] - y) ? b : a; })[0];
        }
        setSheet(pick);
        setTimeout(function () { sheet.dragged = false; }, 0);
      }
      ui.panel.addEventListener('pointerdown', down);
      ui.panel.addEventListener('pointermove', move);
      ui.panel.addEventListener('pointerup', up);
      ui.panel.addEventListener('pointercancel', up);
    })();
    function onLayout() {
      if (mqSheet.matches) { if (!ui.card.hidden) setCardFit(cardNeed()); setSheet(sheet.pos, true); }
      else { ui.panel.style.transform = ''; ui.mapwrap.style.removeProperty('--stl-sheet-h'); ui.mapwrap.style.height = ''; }
      if (M.map) M.map.invalidateSize();
      fitPlaceholder();
    }
    if (mqSheet.addEventListener) mqSheet.addEventListener('change', onLayout);
    window.addEventListener('resize', function () { clearTimeout(onLayout.t); onLayout.t = setTimeout(onLayout, 150); });
    /* QA2-10: the full placeholder ('2250 or Gosford') only when it fits the visible input; on the narrowest
       phones the short one (data-ph-short). Re-measured on layout changes and once the web font has loaded.
       No attribute, or any failure, keeps the full placeholder. */
    function fitPlaceholder() {
      var el = ui.input, short = el && el.getAttribute('data-ph-short');
      if (!short) return;
      try {
        var full = fitPlaceholder.full || (fitPlaceholder.full = el.getAttribute('placeholder') || '');
        var cs = getComputedStyle(el), ps = getComputedStyle(el, '::placeholder');
        var ctx = fitPlaceholder.ctx || (fitPlaceholder.ctx = document.createElement('canvas').getContext('2d'));
        ctx.font = ps.fontStyle + ' ' + ps.fontWeight + ' ' + ps.fontSize + ' ' + ps.fontFamily;
        var room = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        if (!(room > 0)) return;
        var want = ctx.measureText(full).width <= room ? full : short;
        if (el.getAttribute('placeholder') !== want) el.setAttribute('placeholder', want);
      } catch (e) { /* keep what is there */ }
    }
    fitPlaceholder();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitPlaceholder);

    /* ---------------- map (T02, T05, T06, T07) ---------------- */
    function mapFail(msg) {
      if (M.state === 'failed') return;
      M.state = 'failed';
      ui.map.classList.add('is-failed');
      ui.mapTxt.textContent = msg || 'Map unavailable, the list below has every stockist.';
    }
    function ensureMap() {
      if (M.state !== 'idle' || !cfg.mapEnabled || !ui.map) return;
      M.state = 'loading';
      loadCss(assets.mapCss);
      var timer = setTimeout(function () { mapFail(); }, 20000);
      function fail() { clearTimeout(timer); mapFail(); }
      function haveL() {
        loadScript(assets.clusterJs, function () {
          clearTimeout(timer);
          if (!window.L || !L.markerClusterGroup) return mapFail();
          try { buildMap(); } catch (e) { mapFail(); if (window.console) console.error('stockist map', e); }
        }, fail);
      }
      if (window.L && L.map) haveL(); else loadScript(assets.leafletJs, function () { if (!window.L) return fail(); haveL(); }, fail);
    }
    function dropSVG(sel, small) {
      var w = small ? 20 : 30, h = small ? 27 : 40, mono = attrEsc(assets.monogram || '');
      return '<svg class="stl-pin-drop' + (sel ? ' is-sel' : '') + '" width="' + w + '" height="' + h + '" viewBox="0 0 30 40" aria-hidden="true" focusable="false">' +
        '<path class="b" d="M15 38.5C15 38.5 2.5 24.5 2.5 14.2A12.5 12.5 0 0 1 27.5 14.2C27.5 24.5 15 38.5 15 38.5Z" stroke="#2C2C2C" stroke-width="2" stroke-linejoin="round"/>' +
        '<circle cx="15" cy="14.5" r="8.3" fill="#FAF9EE" stroke="#2C2C2C" stroke-width="1.6"/>' +
        (mono ? '<image href="' + mono + '" x="8.4" y="7.9" width="13.2" height="13.2"/>' : '') +
        '<circle cx="10.2" cy="4.4" r="1.2" fill="#FFDA22" stroke="#2C2C2C" stroke-width=".6"/><circle cx="15" cy="3.2" r="1.2" fill="#FFDA22" stroke="#2C2C2C" stroke-width=".6"/><circle cx="19.8" cy="4.4" r="1.2" fill="#FFDA22" stroke="#2C2C2C" stroke-width=".6"/></svg>';
    }
    function pinIcon(p, sel) {
      var tall = style === 'drop', big = style === 'sticker' && sel;
      var size = big ? [64, 64] : (tall ? [44, 52] : [44, 44]);
      var anchor = tall ? [22, 50] : [size[0] / 2, size[1] / 2];
      var cls = 'stl-hit' + (tall ? ' stl-hit--tall' : '') + (big ? ' stl-hit--big' : '');
      return L.divIcon({ className: 'stl-pinwrap', html: '<div class="' + cls + '">' + pinArt(p, sel, false) + '</div>', iconSize: size, iconAnchor: anchor });
    }
    function clusterSize(n) { return n < 10 ? 38 : (n < 50 ? 44 : 52); }
    function clusterHTML(n) {
      var s = clusterSize(n), big = n >= 20, fs = s < 40 ? 14 : (s < 50 ? 16 : 18);
      if (style === 'lid' || style === 'dot') return '<div class="stl-cl-lid' + (big ? ' is-big' : '') + '" style="width:' + s + 'px;height:' + s + 'px"><b style="font-size:' + fs + 'px">' + n + '</b></div>';
      if (style === 'drop') {
        var w = Math.round(s * 0.9), h = Math.round(s * 1.12);
        return '<svg class="stl-cl-drop' + (big ? ' is-big' : '') + '" width="' + w + '" height="' + h + '" viewBox="0 0 40 50" aria-hidden="true" focusable="false"><rect x="7" y="1.5" width="26" height="9" rx="2.5" fill="#2C2C2C"/><rect x="3" y="9.5" width="34" height="39" rx="7" fill="#FAF9EE" stroke="#2C2C2C" stroke-width="2.4"/><rect class="band" x="4.2" y="19" width="31.6" height="20" stroke="#2C2C2C" stroke-width="1.6"/><text x="20" y="34.5" text-anchor="middle" font-size="' + (n > 99 ? 12 : 14) + '">' + n + '</text></svg>';
      }
      var pts = [], k;
      for (k = 0; k < 24; k++) { var a = Math.PI * k / 12 - Math.PI / 2, rr = (k % 2 === 0) ? 23 : 17; pts.push((25 + rr * Math.cos(a)).toFixed(1) + ',' + (25 + rr * Math.sin(a)).toFixed(1)); }
      return '<svg class="stl-cl-stk' + (big ? ' is-big' : '') + '" width="' + (s + 4) + '" height="' + (s + 4) + '" viewBox="0 0 50 50" aria-hidden="true" focusable="false"><polygon class="star" points="' + pts.join(' ') + '"/><text x="25" y="30.5" text-anchor="middle" font-size="' + (n > 99 ? 12 : 15) + '">' + n + '</text></svg>';
    }
    function clusterIcon(c) {
      var n = c.getChildCount(), s = clusterSize(n);
      var box = style === 'drop' ? [Math.round(s * 0.9) + 4, Math.round(s * 1.12) + 4] : [s + 8, s + 8];
      if (box[0] < 44) box = [44, Math.max(44, box[1])];
      return L.divIcon({ className: 'stl-clwrap', html: '<div class="stl-hit" style="width:' + box[0] + 'px;height:' + box[1] + 'px" title="' + n + ' stockists, zoom in">' + clusterHTML(n) + '</div>', iconSize: box });
    }
    function tileLayer() {
      var url = String(cfg.tileUrl || '');
      if (!/^https:\/\//.test(url) || url.indexOf('{z}') < 0 || url.indexOf('{x}') < 0 || url.indexOf('{y}') < 0) url = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
      if (!cfg.tileRetina) url = url.replace('{r}', '');
      var attr = (cfg.tileAttribution || '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors') +
        ' | <a href="https://www.openstreetmap.org/fixthemap" target="_blank" rel="noopener">Fix the map</a>';
      return L.tileLayer(url, { maxZoom: +cfg.tileMaxZoom || 19, attribution: attr, updateWhenZooming: false, updateInterval: 400, keepBuffer: 2 });
    }
    function buildMap() {
      var R = mqReduce.matches;
      var lats = pins.map(function (p) { return p.lat; }), lngs = pins.map(function (p) { return p.lng; });
      var s = Math.min.apply(null, lats), n = Math.max.apply(null, lats), w = Math.min.apply(null, lngs), e = Math.max.apply(null, lngs);
      M.allBounds = L.latLngBounds([s, w], [n, e]);
      var touchInline = coarse;
      M.maxB = L.latLngBounds([s - 12, w - 12], [n + 12, e + 12]);
      var map = L.map(ui.map, {
        zoomSnap: 0.25, zoomDelta: 1, minZoom: 3, maxZoom: +cfg.tileMaxZoom || 19,
        maxBounds: M.maxB, maxBoundsViscosity: 0.9,
        zoomAnimation: !R, fadeAnimation: !R, markerZoomAnimation: !R, inertia: !R,
        dragging: !touchInline, tap: false, scrollWheelZoom: true, worldCopyJump: false, zoomControl: false
      });
      M.map = map;
      /* phones: zoom buttons sit top right under the floating chips; the attribution goes bottom left */
      L.control.zoom({ position: mqSheet.matches ? 'topright' : 'topleft' }).addTo(map);
      map.attributionControl.setPrefix('<a href="https://leafletjs.com" target="_blank" rel="noopener">Leaflet</a>');
      /* phones: the attribution sits bottom left, width capped in CSS, so it never runs under the
         top-right zoom buttons however far the sheet lifts it (QA-03) */
      if (mqSheet.matches) map.attributionControl.setPosition('bottomleft');
      var tl = tileLayer().addTo(map);
      M.tiles = tl;
      /* QA3-02: the static poster fades on the first tile that really loaded, never on a timer or on a 'load'
         that only means every tile errored. Tiles down: the poster stays while the view is the one it was drawn
         for (the first fit), and a note says the list has every stockist. A late tile clears the note. */
      M.tilesOk = 0; M.tilesBad = 0;
      tl.on('tileload', function () { if (M.tilesOk++) return; ui.map.classList.add('is-tiled'); ui.map.classList.remove('is-notiles', 'is-offposter'); });
      tl.on('tileerror', function () { M.tilesBad++; });
      function noTiles() {
        if (M.tilesOk || ui.map.classList.contains('is-notiles')) return;
        ui.map.classList.add('is-notiles');
        ui.mapTxt.textContent = 'Map tiles unavailable, the list below has every stockist.';
      }
      tl.on('load', function () { if (!M.tilesOk && M.tilesBad) noTiles(); });
      setTimeout(noTiles, 12000);
      if (L.MarkerCluster && L.MarkerCluster.prototype.options) L.MarkerCluster.prototype.options.keyboard = false;
      M.cluster = L.markerClusterGroup({
        /* Spec: 60 / 44 / 28 px and no clustering from z15. From z15 the radius is 1 px instead of
           disableClusteringAtZoom, so distinct shops never cluster at street level but shops sharing
           one address (Pengilley's and Ritchies IGA Erina Heights) stay a "2" that spiderfies at any zoom. */
        maxClusterRadius: function (z) { return z <= 6 ? 60 : (z <= 10 ? 44 : (z < 15 ? 28 : 1)); },
        spiderfyOnMaxZoom: true, spiderfyDistanceMultiplier: 1.6,
        showCoverageOnHover: false, chunkedLoading: true, removeOutsideVisibleBounds: true,
        animate: !R, animateAddingMarkers: false, iconCreateFunction: clusterIcon
      });
      pins.forEach(function (p) {
        var label = p.name + ', ' + p.suburb;
        var m = L.marker([p.lat, p.lng], { icon: pinIcon(p, p.id === S.sel), keyboard: false, title: label, alt: label, riseOnHover: true });
        m.on('click', function () { select(p.id, { from: 'pin' }); });
        M.markers[p.id] = m;
      });
      map.addLayer(M.cluster);
      syncMarkers();
      fitAll();
      M.home = { c: map.getCenter(), z: map.getZoom() };
      map.on('moveend', function () {
        if (M.tilesOk) return;
        var d = map.latLngToContainerPoint(M.home.c).distanceTo(map.getSize().divideBy(2));
        ui.map.classList.toggle('is-offposter', Math.abs(map.getZoom() - M.home.z) > 0.01 || d > 8);
      });
      if (S.sel && M.markers[S.sel]) M.markers[S.sel].setZIndexOffset(1000);
      ui.map.classList.add('is-ready');
      M.state = 'ready';
      gestures(map, touchInline);
      /* catch up with whatever the shopper did while the map loaded */
      if (S.sel) { var p = byId[S.sel]; moveTo({ latlng: [p.lat, p.lng], zoom: 15 }, { instant: true }); }
      else if (S.mode !== 'all') fitResults(S.mode === 'near', true);
      else if (S.state) fitPins(stateFilter(pins), true);
      map.on('keydown', function (ev) { if (ev.originalEvent.key === 'Escape' && !ui.card.hidden) closeCard(true); });
    }
    function syncMarkers() {
      if (!M.cluster) return;
      M.cluster.clearLayers();
      var list = stateFilter(pins).map(function (p) { return M.markers[p.id]; });
      M.cluster.addLayers(list);
      if (S.origin && S.mode === 'search') {
        if (!M.here) M.here = L.marker([S.origin.lat, S.origin.lng], { icon: L.divIcon({ className: 'stl-pinwrap', html: '<div class="stl-here"></div>', iconSize: [22, 22] }), keyboard: false, interactive: false, zIndexOffset: -100 }).addTo(M.map);
        else M.here.setLatLng([S.origin.lat, S.origin.lng]);
      } else if (M.here) { M.map.removeLayer(M.here); M.here = null; }
      if (S.origin && S.mode === 'near') {
        if (M.you) M.map.removeLayer(M.you);
        M.you = L.marker([S.origin.lat, S.origin.lng], { icon: L.divIcon({ className: 'stl-pinwrap', html: '<div class="stl-you"></div>', iconSize: [18, 18] }), keyboard: false, interactive: false, zIndexOffset: -100 }).addTo(M.map);
      } else if (M.you) { M.map.removeLayer(M.you); M.you = null; }
    }
    function pad() {
      if (!mqSheet.matches) return { paddingTopLeft: [40, 40], paddingBottomRight: [40, 40] };
      /* while scrolling the map into view, frame for where the sheet will sit, not where it is */
      var v = (Date.now() - (S.scrolledAt || 0) < 1200) ? sheetVisible() : sheetCover();
      /* QA-02: keep the fit box at least 40% of the map (and 120 px) tall, so a short map with a tall
         cover frames the pins at a low zoom instead of inverting the box */
      var sy = M.map ? M.map.getSize().y : ui.map.clientHeight, top = Math.min(70, Math.round(sy * 0.2));
      var minBox = Math.max(120, Math.round(sy * 0.4)), bottom = 24 + v;
      if (sy - top - bottom < minBox) bottom = Math.max(0, sy - top - minBox);
      return { paddingTopLeft: [24, top], paddingBottomRight: [24, bottom] };
    }
    /* height the bottom-left attribution takes over the map strip on phones (QA-03) */
    function attrH() {
      var a = M.map && M.map.attributionControl && M.map.attributionControl.getContainer();
      return (mqSheet.matches && a) ? a.offsetHeight + 4 : 0;
    }
    /* the national view; if a fit ever lands outside a sane national zoom, settle on the continent (QA-02) */
    function fitAll() {
      var map = M.map;
      map.fitBounds(M.allBounds, fitOpts({ animate: false }));
      if (!isFinite(map.getZoom()) || map.getZoom() > 6) map.setView(M.allBounds.getCenter(), map.getMinZoom(), { animate: false });
    }
    function fitOpts(extra) { var o = pad(); for (var k in extra) o[k] = extra[k]; return o; }
    /* One helper decides every camera move (motion spec 4.1). Returns true when the camera moves. */
    function moveTo(t, o) {
      o = o || {};
      var map = M.map, R = mqReduce.matches || o.instant;
      var target = t.bounds ? map.getBoundsZoom(t.bounds, false, L.point(0, 0)) : t.zoom;
      var center = t.bounds ? t.bounds.getCenter() : L.latLng(t.latlng);
      if (t.bounds) {
        var p = pad(), tz = Math.min(o.maxZoom || 18, map.getBoundsZoom(t.bounds, false, L.point(p.paddingTopLeft).add(p.paddingBottomRight)));
        target = tz;
      }
      var same = Math.abs(target - map.getZoom()) < 0.01 && map.latLngToContainerPoint(center).distanceTo(map.latLngToContainerPoint(map.getCenter())) < 2 && !t.bounds;
      M.instant = false;
      if (same) return false;
      closeSpider();
      holdBounds();
      if (R) {
        M.instant = true;
        if (t.bounds) map.fitBounds(t.bounds, fitOpts({ maxZoom: o.maxZoom, animate: false })); else map.setView(t.latlng, t.zoom, { animate: false });
        releaseBounds(true);
        return true;
      }
      /* long hop from a zoomed-in view (Erina to Perth): crossfade instead of a tile-hungry flight */
      if (map.distance(map.getCenter(), center) > LONG_HOP_M && !map.getBounds().contains(center)) { crossfade(t, o); return true; }
      var dz = Math.abs(target - map.getZoom());
      var dur = Math.min(0.95, Math.max(0.45, 0.25 + 0.08 * dz)); /* spec clamp 0.45 to 1.0 s; 0.95 keeps the measured flight, frames included, under 1.0 s */
      if (t.bounds) map.flyToBounds(t.bounds, fitOpts({ maxZoom: o.maxZoom, duration: dur, easeLinearity: 0.25 }));
      else map.flyTo(t.latlng, t.zoom, { duration: dur, easeLinearity: 0.25 });
      releaseBounds(false);
      return true;
    }
    /* maxBounds re-pans the map on every moveend. On a phone at national zoom, growing the map started
       that pan, flyTo's own stop fired a moveend that started another, and its moveend landed mid-flight:
       markercluster then rebuilt at the half-way zoom and the chosen pin was never drawn at z15. So the
       bounds step aside for our own camera moves and come back when the move has landed. */
    /* markercluster folds a spiderfy away on 'zoomanim', which flyTo never fires: a flight that started
       from an open spiderfy (a co-located pair tapped below z15) left an empty marker layer at z15.
       Fold it away, without animation, before the camera moves (vendored markercluster 1.5.3). */
    function closeSpider() {
      var sp = M.cluster && M.cluster._spiderfied;
      if (sp && typeof sp._noanimationUnspiderfy === 'function') { sp._noanimationUnspiderfy(); M.cluster._spiderfied = null; }
    }
    function holdBounds() {
      var map = M.map; clearTimeout(holdBounds.t);
      if (map && map.options.maxBounds) map.setMaxBounds(null);
    }
    function releaseBounds(now) {
      var map = M.map; if (!map || !M.maxB) return;
      function back() { clearTimeout(holdBounds.t); holdBounds.t = setTimeout(function () { if (!map.options.maxBounds) map.setMaxBounds(M.maxB); }, 0); }
      if (now) back(); else map.once('moveend', back);
    }
    function crossfade(t, o) {
      var pane = M.map.getPane('mapPane'), map = M.map;
      pane.classList.add('is-fade');
      setTimeout(function () {
        if (t.bounds) map.fitBounds(t.bounds, fitOpts({ maxZoom: o.maxZoom, animate: false })); else map.setView(t.latlng, t.zoom, { animate: false });
        releaseBounds(true);
        var done = false;
        function back() { if (done) return; done = true; pane.classList.remove('is-fade'); }
        M.tiles.once('load', back); setTimeout(back, 250);
      }, 120);
    }
    /* The card opens on moveend, never before the camera arrives (motion spec 4.1). */
    function moveThen(t, o, fn) {
      if (!M.map) { fn(); return; }
      var done = false;
      function go() { if (done) return; done = true; M.map.off('moveend', go); fn(); }
      /* listen only once the move has started: flyTo stops any running pan first, and that stop fires a
         moveend of its own, which used to open the card before the camera had left */
      if (!moveTo(t, o) || M.instant) { go(); return; }
      M.map.on('moveend', go);
      setTimeout(go, 1600);
    }
    function resetView() { closeCard(false); moveTo({ bounds: M.allBounds }); }
    function fitPins(list, instant) {
      if (!list.length) return;
      var b = L.latLngBounds(list.map(function (p) { return [p.lat, p.lng]; }));
      if (list.length === 1) moveTo({ latlng: b.getCenter(), zoom: 13 }, { instant: instant });
      else moveTo({ bounds: b }, { maxZoom: 13, instant: instant });
    }
    function fitResults(near, instant) {
      var items = stateFilter(S.results || []), pts = [[S.origin.lat, S.origin.lng]];
      items.slice(0, near ? 5 : 3).forEach(function (x) { pts.push([x.p.lat, x.p.lng]); });
      moveTo({ bounds: L.latLngBounds(pts) }, { maxZoom: 13, instant: instant });
    }
    /* T07: desktop wheel zoom only after a click or focus, or with Ctrl or Cmd; touch pans with two fingers. */
    function hint(msg, ms) {
      ui.hint.textContent = msg; ui.hint.classList.add('is-on');
      clearTimeout(hint.t); hint.t = setTimeout(function () { ui.hint.classList.remove('is-on'); }, ms);
    }
    function gestures(map, touchInline) {
      var c = map.getContainer(), active = false;
      c.addEventListener('wheel', function (e) {
        if (active || e.ctrlKey || e.metaKey) return;
        e.stopImmediatePropagation();
        hint(/Mac/.test(navigator.platform) ? 'Use \u2318 + scroll to zoom the map' : 'Use Ctrl + scroll to zoom the map', 1000);
      }, { capture: true, passive: true });
      c.addEventListener('mousedown', function () { active = true; });
      c.addEventListener('focus', function () { active = true; });
      c.addEventListener('mouseleave', function () { active = false; });
      c.addEventListener('blur', function () { active = false; });
      if (touchInline) {
        var n = 0, moved = false;
        c.addEventListener('touchstart', function (e) { n = e.touches.length; moved = false; }, { passive: true });
        c.addEventListener('touchmove', function (e) {
          if (e.touches.length === 1 && n === 1 && !moved) { moved = true; hint('Use two fingers to move the map', 1200); }
        }, { passive: true });
      }
    }

    /* read-only handle for the acceptance suite (build/tests); holds no personal data */
    window.__stockistLocator = { S: S, M: M, byId: byId, pins: pins, style: style };

    /* ---------------- boot ---------------- */
    render();
    if (mqSheet.matches) setSheet('peek', true);
    if (cfg.mapEnabled && ui.map) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); ensureMap(); }
        }, { rootMargin: '600px' });
        io.observe(ui.map);
      } else ensureMap();
    }
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };
    setTimeout(function () { idle(function () { loadPlaces(); }); }, 4000);
    try {
      var q0 = new URL(location.href).searchParams.get('q');
      if (q0) { ui.input.value = q0; runSearch(q0, { fromUrl: true }); }
    } catch (e) { /* old browser */ }
  }

  /* recommend-a-store form: inline validation, native submit (T11) */
  function recForm() {
    var f = document.querySelector('[data-stl-rec]');
    if (!f) return;
    var ok = f.querySelector('[data-stl-rec-ok]');
    if (ok) announce(ok.textContent);
    f.addEventListener('submit', function (e) {
      var bad = null;
      Array.prototype.forEach.call(f.querySelectorAll('input[required]'), function (i) {
        var err = document.getElementById(i.id + '-err'), msg = '';
        if (!i.value.trim()) msg = 'Please fill this in.';
        else if (i.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(i.value.trim())) msg = 'That email does not look right.';
        if (err) err.textContent = msg;
        if (msg) { i.setAttribute('aria-invalid', 'true'); if (!bad) bad = i; } else i.removeAttribute('aria-invalid');
      });
      if (bad) { e.preventDefault(); bad.focus(); announce('Please check the highlighted fields.'); }
    });
  }

  function boot() {
    var roots = document.querySelectorAll('.stl[data-stockist-contract="v2"]');
    Array.prototype.forEach.call(roots, function (r) {
      try { Locator(r); } catch (e) { if (window.console) console.error('stockist locator', e); }
      /* separate from the Locator, so the directory's buttons work even if the map code fails */
      try { dirChips(r); } catch (e) { if (window.console) console.error('stockist directory', e); }
    });
    recForm();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
